// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './icons'
import util from '@/assets/js/util.js'
import '@/styles/index.scss'
import './interceptors'	// axios拦截器
import '@/assets/plugins/vue.sdk.js' //埋点
import jointImageSuffix from '@kkmh/image-format';
import infiniteScroll from 'vue-infinite-scroll'
import VueLazyload from 'vue-lazyload';
import { compress } from '@kk/utils';

Vue.use(VueLazyload, {
  preLoad: 1.2,
  attempt: 2,
  filter:{
    progressive (listener, options) {
      let src     = listener.src;
      let width   = listener.el.getAttribute('data-width');
      listener.src = jointImageSuffix({ src:src, width:width, quality:'h', p:true });
    },
  }
})

// @ts-ignore
Date = util.reConstructorDate()

Vue.use(element)
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.prototype.$axios = axios

Vue.mixin({
    filters: {
      compress
    }
});

// 捕捉 chunk loading 失败，重新加载页面，更新资源
router.onError(error => {
	const pattern = /Loading chunk (\d)+ failed/g
  // @ts-ignore
	const path = router.history.pending.fullPath
	if (error.message.match(pattern)) {
		window.location.href = `${ location.href.split('#')[0] }#${ path }`
	} else {
        throw error;
    }
})

new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',
	data: {
		bus: new Vue()
	}
})
